import { Component } from '@angular/core';
import { IStatusPanelAngularComp } from 'ag-grid-angular';
import { GridApi, SelectionChangedEvent } from 'ag-grid-community';
import { navData } from 'src/app/data/nav-data';
import { CommonService } from 'src/app/services/common.service';
import { ReportsService } from 'src/app/services/reports.service';

@Component({
  selector: 'status-bar-recommendation-actions',
  template: ` <div
    *ngIf="this.reportService.shouldDisplayMassCoachingActions"
    class="recommendation-actions-container"
    fxLayout="row"
    fxLayoutAlign="center center"
  >
    <button class="assign-btn" [disabled]="!hasSelectedRows" (click)="acceptCoaching()" mat-button vrm-button>
      {{ 'GENERIC.assign' | translate }}
    </button>
    <button class="reject-btn" [disabled]="!hasSelectedRows" (click)="rejectCoaching()" mat-button>
      {{ 'GENERIC.reject' | translate }}
    </button>
  </div>`,
  styles: [
    `
      .assign-btn {
        margin-left: 10px;
      }
    `,
  ],
})
export class StatusBarRecommendationActionsComponent implements IStatusPanelAngularComp {
  private gridApi: GridApi;
  private interventionType: string;
  public hasSelectedRows: boolean;

  constructor(public reportService: ReportsService, private cService: CommonService) {}

  agInit(params: any): void {
    this.gridApi = params.api;
    this.interventionType = this.getInterventionType();

    this.gridApi.addEventListener('selectionChanged', (event: SelectionChangedEvent) => {
      this.hasSelectedRows = event.api.getSelectedNodes().length > 0;
    });
  }

  getInterventionType(): string | null {
    let interventionType = null;
    const reportMeta = this.reportService.currentReportMeta;

    if (reportMeta.information && reportMeta.information.recommendationsReport) {
      interventionType = reportMeta.information.recommendationsReport.intervention;
    }

    return interventionType;
  }

  public acceptCoaching(): void {
    const { selectedData, coachingData } = this.getCoachingData();
    const subscription = this.reportService.assignRecommendedCoaching(coachingData).subscribe(() => {
      this.reportService.triggerRowsDeleted(selectedData);
      this.cService.triggerMenuBadgeCountUpdateObservable(navData[this.interventionType].idName);
      subscription.unsubscribe();
    });
  }

  public rejectCoaching(): void {
    const { selectedData, coachingData } = this.getCoachingData();
    const subscription = this.reportService.rejectRecommendCoaching(coachingData).subscribe(() => {
      this.reportService.triggerRowsDeleted(selectedData);
      this.cService.triggerMenuBadgeCountUpdateObservable(navData[this.interventionType].idName);
      subscription.unsubscribe();
    });
  }

  private getCoachingData() {
    const selectedNodes = this.gridApi.getSelectedNodes();

    return {
      selectedData: selectedNodes.map((node) => node.data),
      coachingData: selectedNodes.map((node) => node.data.id),
    };
  }
}
